module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDBMMTIuMzYwNyA3LjYzOTMySDIwTDEzLjgxOTcgMTIuMzYwN0wxNi4xODAzIDIwTDEwIDE1LjI3ODZMMy44MTk2NiAyMEw2LjE4MDM0IDEyLjM2MDdMMCA3LjYzOTMySDcuNjM5MzJMMTAgMFoiIGZpbGw9IiNGRjk4MDAiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/newCheckout/star.svg
// module id = 1188
// module chunks = 0